import { render, staticRenderFns } from "./ConfigInputS3Image.vue?vue&type=template&id=a8ae04e6&scoped=true&"
import script from "./ConfigInputS3Image.vue?vue&type=script&lang=js&"
export * from "./ConfigInputS3Image.vue?vue&type=script&lang=js&"
import style0 from "./ConfigInputS3Image.vue?vue&type=style&index=0&id=a8ae04e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ae04e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8ae04e6')) {
      api.createRecord('a8ae04e6', component.options)
    } else {
      api.reload('a8ae04e6', component.options)
    }
    module.hot.accept("./ConfigInputS3Image.vue?vue&type=template&id=a8ae04e6&scoped=true&", function () {
      api.rerender('a8ae04e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputS3Image.vue"
export default component.exports